import React, { useState, useEffect } from 'react';

import { useTheme } from 'styled-components';

import { FaFileExcel } from 'react-icons/fa';
import { FaFilePdf } from 'react-icons/fa';
import { IoMdArrowDropup, IoMdArrowDropdown } from 'react-icons/io';
import { FaTag } from 'react-icons/fa';
import { FaTrophy } from 'react-icons/fa';
import { FaMedal } from 'react-icons/fa';

import api from '~/services/api';

import { exportCsv } from '~/helpers/csv';
import { exportPdf } from '~/helpers/pdf';

import {
  Scroll,
  Container,
  Header,
  Progress,
  Loading,
  Grid,
  GridLine,
  GridHeadItem,
  GridItem,
} from '~/components';

import { Champion, GraphArea, LoadArea, Tags, ToogleInfo } from './styles';

import Grafico from './Grafico';

import RelatorioVendaTopProdutosType from '~/@types/relatoriovendatopprodutos';
import RelatorioVendaTopProdutosProdutoType from '~/@types/relatoriovendatoprodutosproduto';
import { Align } from '../Produtos/styles';
import { CountItem, ProgressTag } from '../Dashboard/styles';

const VendasTopProdutos: React.FC = () => {

  const { colors } = useTheme();

  const [inLoad, setInLoad] = useState(false);

  const [topprodutos, setTopprodutos] = useState<
    RelatorioVendaTopProdutosType[]
  >([]);
  const [vendasTopProdutoVisibilidade, setVendasTopProdutoVisibilidade] =
    useState(true);
  const [moduloGrafico, setModuloGrafico] = useState('hoje');

  // MODULO (TOPPRODUTOS)
  const filtrarTopProdutosPorModulo = (
    pModuloGrafico: string,
    pGraficos: RelatorioVendaTopProdutosType[],
  ) => {
    const _topprodutos: RelatorioVendaTopProdutosProdutoType[] = [];

    let c;
    for (c in pGraficos) {
      const relatorio = pGraficos[c];
      if (relatorio.nome === pModuloGrafico) {
        let d;
        for (d in relatorio.topprodutos) {
          const topproduto = relatorio.topprodutos[d];
          _topprodutos.push(topproduto);
        }
      }
    }

    return _topprodutos;
  };

  const gerarRelatorioGraficoCSV = () => {
    let data: string[] = [];

    data.push('IDPRODUTO;SKU;NOME;QUANTIDADE;TOTAL');

    const _topprodutos = filtrarTopProdutosPorModulo(
      moduloGrafico,
      topprodutos,
    );

    let d;
    for (d in _topprodutos) {
      const topproduto = _topprodutos[d];

      data.push(
        `${topproduto.idproduto};${topproduto.sku};${topproduto.nome};${topproduto.qtdtotal};${topproduto.total}`,
      );
    }

    const csv = data.join('\n');

    exportCsv(csv, `TOP PRODUTOS - ${moduloGrafico.toUpperCase()}`);
  };

  const gerarRelatoriosGraficoPDF = () => {
    const cabecalho = ['IDPRODUTO', 'SKU', 'NOME', 'QUANTIDADE', 'TOTAL'];

    const data: string[][] = [];

    const _topprodutos = filtrarTopProdutosPorModulo(
      moduloGrafico,
      topprodutos,
    );

    let d;
    for (d in _topprodutos) {
      const topproduto = _topprodutos[d];

      const linha: string[] = [];

      linha.push(`${topproduto.idproduto}`);
      linha.push(`${topproduto.sku}`);
      linha.push(`${topproduto.nome}`);
      linha.push(`${topproduto.qtdtotal}`);
      linha.push(`${topproduto.total}`);

      data.push(linha);
    }

    exportPdf(cabecalho, data, `TOP PRODUTOS - ${moduloGrafico.toUpperCase()}`);
  };

  useEffect(() => {
    const fetchVendasTopProdutos = async () => {
      try {
        setInLoad(true);
        setTopprodutos([]);

        const ano = new Date().getFullYear();
        const modulo = 'vendas_top_produtos';

        const response = await api.get(
          `relatorios?ano=${ano}&modulo=${modulo}`,
        );

        const { data } = response;

        if (data && Array.isArray(data) && data.length) {
          setTopprodutos(data);
        }

        setInLoad(false);
      } catch (e) {
        setInLoad(false);
      }
    };
    fetchVendasTopProdutos();
  }, []);

  return (
    <>
      {inLoad ? <Progress /> : null}

      <Scroll>
        <Container>
          <Header
            title="Top Produtos"
            subtitle="Confira as métricas de vendas dos produtos mais vendidos"
            icon={
              <>
                <FaTrophy size={32} color={colors.IC1} />
              </>
            }
          />

          {inLoad ? (
            <LoadArea>
              <Loading color={colors.IC1} size={42} />
            </LoadArea>
          ) : null}

          {topprodutos.length ? (
            <GraphArea>
              <header>
                <i>
                  <FaTrophy size={26} color={colors.IC1} />
                </i>
                <p>
                  <h1>Top Produtos</h1>
                  <h2>
                    Confira as métricas de vendas dos produtos mais vendidos
                  </h2>
                </p>

                <div>
                  <button
                    className="excel"
                    onClick={gerarRelatorioGraficoCSV}
                    title="Exportar para Excel"
                  >
                    <FaFileExcel size={22} color={colors.IC2} />
                    <div>
                      <h3>EXPORTAR</h3>
                      <h2>EXCEL</h2>
                    </div>
                  </button>
                  <button
                    className="pdf"
                    onClick={gerarRelatoriosGraficoPDF}
                    title="Exportar para PDF"
                  >
                    <FaFilePdf size={22} color={colors.IC2} />
                    <div>
                      <h3>EXPORTAR</h3>
                      <h2>PDF</h2>
                    </div>
                  </button>
                </div>
              </header>

              <Tags>
                <div>
                  <button
                    className={moduloGrafico === 'hoje' ? 'active' : ''}
                    onClick={() => setModuloGrafico('hoje')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Hoje</span>
                  </button>
                  <button
                    className={
                      moduloGrafico === 'ultimos-7-dias' ? 'active' : ''
                    }
                    onClick={() => setModuloGrafico('ultimos-7-dias')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Últimos 7 Dias</span>
                  </button>
                  <button
                    className={moduloGrafico === 'mes-atual' ? 'active' : ''}
                    onClick={() => setModuloGrafico('mes-atual')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Mês Atual</span>
                  </button>
                  <button
                    className={moduloGrafico === 'mes-passado' ? 'active' : ''}
                    onClick={() => setModuloGrafico('mes-passado')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Mês Passado</span>
                  </button>
                  <button
                    className={moduloGrafico === 'ano-atual' ? 'active' : ''}
                    onClick={() => setModuloGrafico('ano-atual')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Ano Atual</span>
                  </button>
                  <button
                    className={moduloGrafico === 'ano-passado' ? 'active' : ''}
                    onClick={() => setModuloGrafico('ano-passado')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Ano Passado</span>
                  </button>
                </div>
              </Tags>

              <main>
                <div>
                  <Grafico
                    topprodutos={filtrarTopProdutosPorModulo(
                      moduloGrafico,
                      topprodutos,
                    )}
                  />
                </div>
              </main>

              <footer>
                {vendasTopProdutoVisibilidade ? (
                  <Grid>
                    <GridLine>
                      <GridHeadItem title="" width={40} />
                      <GridHeadItem title="SKU" width={100} />
                      <GridHeadItem title="Nome" />
                      <GridHeadItem title="Quantidade" width={150} />
                      <GridHeadItem title="Total" width={150} />
                    </GridLine>

                    {filtrarTopProdutosPorModulo(
                      moduloGrafico,
                      topprodutos,
                    ).map(topproduto => (
                      <GridLine key={topproduto.idproduto}>
                        <GridItem width={40}>
                          <Align>
                            <CountItem>{topproduto.posicao}</CountItem>
                            {topproduto._posicao <= 3 ? (
                              <Champion>
                                {topproduto._posicao === 1 ? (
                                  <FaTrophy size={18} color={colors.IC1} />
                                ) : (
                                  <FaMedal size={18} color={colors.IC1} />
                                )}
                              </Champion>
                            ) : null}
                          </Align>
                        </GridItem>
                        <GridItem width={100}>
                          <Align>{topproduto.sku}</Align>
                        </GridItem>
                        <GridItem>
                          <Align>
                            <strong>{topproduto.nome.toUpperCase()}</strong>
                          </Align>
                        </GridItem>
                        <GridItem width={150}>
                          <Align>
                            <div>{topproduto.qtdtotal}</div>
                            <ProgressTag>
                              {topproduto.quantidade_porcentagem}%
                            </ProgressTag>
                          </Align>
                        </GridItem>
                        <GridItem width={150}>
                          <Align>
                            <div>
                              {topproduto.total.toLocaleString('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                            </div>
                            <ProgressTag>
                              {topproduto.faturamento_porcentagem}%
                            </ProgressTag>
                          </Align>
                        </GridItem>
                      </GridLine>
                    ))}
                  </Grid>
                ) : null}
                <ToogleInfo
                  onClick={() =>
                    setVendasTopProdutoVisibilidade(
                      !vendasTopProdutoVisibilidade,
                    )
                  }
                >
                  {vendasTopProdutoVisibilidade ? (
                    <IoMdArrowDropup size={32} color={colors.IC1} />
                  ) : (
                    <IoMdArrowDropdown size={32} color={colors.IC1} />
                  )}
                </ToogleInfo>
              </footer>
            </GraphArea>
          ) : null}
        </Container>
      </Scroll>
    </>
  );
};

export default VendasTopProdutos;
